/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/
// React
import React from 'react';
import { Controller } from 'react-hook-form';
// material-ui components
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Timeline from '@mui/lab/Timeline';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
// custom components
import NumberedHeading from "../../../../../../shared-components/forms/NumberedHeading";
import AssessmentLureArray from './AssessmentLureArray';

const SingleReadingMCQuestion = ({control, errors, inputDir }) => {

  return (
    <div>
      <Timeline
        sx={{
          [`& .${timelineItemClasses.root}:before`]: {
            flex: 0,
            padding: 0,
          },
        }}
        className="px-0"
      >
        <TimelineItem>
          <TimelineSeparator>
            <TimelineDot color="secondary" />
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent className="pr-0">
            <div>
              <NumberedHeading number="1" title="Question (Prompt)" instructions='Enter the question text here in the target language.' />
              <Controller
                control={control}
                name="content.question.prompt"
                render={({ field }) => (
                  <>
                    <TextField
                      {...field}
                      className="mt-16 mb-16"
                      label="Text"
                      placeholder="Text"
                      error={!!errors.content?.question?.prompt}
                      helperText={errors.content?.question?.prompt?.message}
                      fullWidth
                      multiline
                      minRows={5}
                      maxRows={10}
                      required
                      dir={inputDir}
                    />
                  </>
                )}
              />

              <Divider className="mt-16" />
              
              <NumberedHeading number="2" title="Paragraph Number" instructions='Enter the paragraph(s) number the question references.' />
              <Controller
                control={control}
                name="content.question.para_num"
                render={({ field }) => (
                  <>
                    <TextField
                      {...field}
                      className="mt-16 mb-16"
                      label="Paragraph Number"
                      placeholder="Paragraph Number"
                      error={!!errors.content?.question?.para_num}
                      helperText={errors.content?.question?.para_num?.message}
                      fullWidth
                      required
                    />
                  </>
                )}
              />

              <Divider className="mt-16" />
              
              <NumberedHeading number="3" title="PDF Page number" instructions='Enter the pdf page number for this material.' />
              <Controller
                control={control}
                name="content.question.pdf_page"
                render={({ field }) => (
                  <>
                    <TextField
                      {...field}
                      className="mt-16 mb-16"
                      label="PDF Page Number"
                      placeholder="PDF Page Number"
                      error={!!errors.content?.question?.pdf_page}
                      helperText={errors.content?.question?.pdf_page?.message}
                      type="number"
                      fullWidth
                    />
                  </>
                )}
              />

              <Divider className="mt-16" />

              <NumberedHeading number="4" title="Lures" instructions='Using the controls below, please add options (lures) for the question.' />
              <Controller
                control={control}
                name="content.question.lures"
                render={({ field }) => <AssessmentLureArray inputDir={inputDir} {...{ control, errors }} />}
              />

              <Divider className="mt-16" />

              <NumberedHeading number="5" title="Multiple Select" instructions="Check the box if there is more than one correct answer." />
              <Controller
                control={control}
                name="content.question.multi_select"
                render={({ field }) => (
                  <FormControlLabel
                    control={
                      <Checkbox 
                        onChange={(ev) => {
                          field.onChange(ev.target.checked);
                        }}
                        checked={field.value}
                      />
                    }
                    label='Multiple Select'
                  />
                )}
              />
            </div>
          </TimelineContent>
        </TimelineItem>
      </Timeline>
    </div>
  );
};

export default SingleReadingMCQuestion;